// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { itemDetailSchema } from '@/items/api/types';
import { z } from 'zod';

/**
 * Represents a BOM item for the update request.
 */
interface BOMItem {
  itemId: string;
  quantity: number;
}

/**
 * Parameters for updating an item's Bill of Materials.
 */
interface UpdateItemBOMParameters {
  bom: BOMItem[];
}

/**
 * Schema for the update item BOM API response.
 */
const updateItemBOMResponseSchema = z
  .object({ data: itemDetailSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, item: data }));

type UpdateItemBOMResponse = z.infer<typeof updateItemBOMResponseSchema>;

/**
 * Updates the Bill of Materials for an item.
 * Only DEVICE type items support BOM.
 * Returns the updated item including fields, accounting, and BOM data.
 */
export async function updateItemBOM(
  key: string,
  parameters: UpdateItemBOMParameters
): Promise<UpdateItemBOMResponse> {
  const url = `/v1/catalog/item/${key}/bom`;
  const response = await api.patch(url, parameters);
  return parseResponse(updateItemBOMResponseSchema, response.data, {
    schemaName: 'UpdateItemBOM',
    endpoint: url,
  });
}
